import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { INewContactPopupParams, useNewContactPopupPresenter } from './NewContactPopup.presenter';
import { NewContactView } from './NewContactView/NewContactView';

export const NewContactPopup: FC<ICommonPopupsProps<INewContactPopupParams | undefined>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useNewContactPopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('new_contact')}
        isOpened
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : undefined}
        onClose={presenter.onClose}
      >
        <NewContactView
          navigateToActiveGroup={props.params?.navigateToActiveGroup}
          onBack={presenter.onBack}
          onClose={presenter.onClose}
        />
      </Popup>
    );
  }
);
